import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AdminRoute } from "./components/AdminRoute";
import { Toaster } from "./components/ui/sonner";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { Home } from "./pages/Home";
import { Cart } from "./pages/Cart";
import { Checkout } from "./pages/Checkout";
import { Profile } from "./pages/Profile";
import { OrderDetail } from "./pages/OrderDetail";
import { Admin } from "./pages/Admin";
import { TopUp } from "./pages/TopUp";
import { LuckyDraw } from "./pages/LuckyDraw";
import { Inventory } from "./pages/Inventory";
import { WalletHistory } from "./pages/WalletHistory";
import { DrawHistory } from "./pages/DrawHistory";
import { TicketHistory } from "./pages/TicketHistory";
import { AccountSettings } from "./pages/AccountSettings";
import { KujiList } from "./pages/KujiList";
import { KujiDetail } from "./pages/KujiDetail";
import { KujiHistory } from "./pages/KujiHistory";
import { KujiInventory } from "./pages/KujiInventory";
import { KujiShippingRequest } from "./pages/KujiShippingRequest";
import { KujiShippingList, KujiShippingDetail } from "./pages/KujiShippingList";
import { LiveWinner } from "./pages/LiveWinner";
import { ProductDetail } from "./pages/ProductDetail";
import { KujiTerms } from "./pages/KujiTerms";
import { ForgotPassword } from "./pages/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          
          <Route path="/kuji-terms" element={<KujiTerms />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/products/:id"
            element={
              <ProtectedRoute>
                <ProductDetail />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/cart"
            element={
              <ProtectedRoute>
                <Cart />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/checkout"
            element={
              <ProtectedRoute>
                <Checkout />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/orders/:orderId"
            element={
              <ProtectedRoute>
                <OrderDetail />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <Admin />
                </AdminRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/topup"
            element={
              <ProtectedRoute>
                <TopUp />
              </ProtectedRoute>
            }
          />

          <Route
            path="/lucky-draw"
            element={
              <ProtectedRoute>
                <LuckyDraw />
              </ProtectedRoute>
            }
          />

          <Route
            path="/inventory"
            element={
              <ProtectedRoute>
                <Inventory />
              </ProtectedRoute>
            }
          />

          <Route
            path="/wallet/history"
            element={
              <ProtectedRoute>
                <WalletHistory />
              </ProtectedRoute>
            }
          />

          <Route
            path="/lucky-draw/history"
            element={
              <ProtectedRoute>
                <DrawHistory />
              </ProtectedRoute>
            }
          />

          <Route
            path="/tickets/history"
            element={
              <ProtectedRoute>
                <TicketHistory />
              </ProtectedRoute>
            }
          />

          <Route
            path="/account/settings"
            element={
              <ProtectedRoute>
                <AccountSettings />
              </ProtectedRoute>
            }
          />

          <Route
            path="/kuji"
            element={
              <ProtectedRoute>
                <KujiList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/kuji/history"
            element={
              <ProtectedRoute>
                <KujiHistory />
              </ProtectedRoute>
            }
          />

          <Route
            path="/kuji/inventory"
            element={
              <ProtectedRoute>
                <Inventory />
              </ProtectedRoute>
            }
          />

          <Route
            path="/kuji/shipping"
            element={
              <ProtectedRoute>
                <KujiShippingList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/kuji/shipping/new"
            element={
              <ProtectedRoute>
                <KujiShippingRequest />
              </ProtectedRoute>
            }
          />

          <Route
            path="/kuji/shipping/:requestId"
            element={
              <ProtectedRoute>
                <KujiShippingDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/kuji/:slug"
            element={
              <ProtectedRoute>
                <KujiDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/live-winner"
            element={
              <ProtectedRoute>
                <LiveWinner />
              </ProtectedRoute>
            }
          />
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
